"use client";
import { jsx as _, jsxs as D } from "react/jsx-runtime";
import m from "clsx";
import { forwardRef as O } from "react";
import { FormItem as R } from "../form-item/form-item.js";
import { useFieldIds as W } from "../hooks/useFieldIds.js";
import '../../../assets/form-input.css';const t = {
  "form-input": "_form-input_61szp_1",
  "form-input--text-area": "_form-input--text-area_61szp_26",
  "form-input__control": "_form-input__control_61szp_31",
  "form-input--disabled": "_form-input--disabled_61szp_36",
  "form-input--select": "_form-input--select_61szp_41",
  "form-input--readonly": "_form-input--readonly_61szp_46",
  "form-input--error": "_form-input--error_61szp_63",
  "form-input--width-2ch": "_form-input--width-2ch_61szp_68",
  "form-input--width-4ch": "_form-input--width-4ch_61szp_74",
  "form-input__control--affix": "_form-input__control--affix_61szp_135",
  "form-input__control--affix--start--3ch": "_form-input__control--affix--start--3ch_61szp_139",
  "form-input__control--affix--start--2ch": "_form-input__control--affix--start--2ch_61szp_143",
  "form-input__control--affix--start--1ch": "_form-input__control--affix--start--1ch_61szp_147",
  "form-input__control--align-center": "_form-input__control--align-center_61szp_151",
  "form-input__control--select": "_form-input__control--select_61szp_155",
  "form-input__affix": "_form-input__affix_61szp_196",
  "form-input__affix--start": "_form-input__affix--start_61szp_206",
  "form-input__affix--end": "_form-input__affix--end_61szp_210",
  "form-input__suffix": "_form-input__suffix_61szp_218",
  "form-input--width-default": "_form-input--width-default_61szp_244",
  "form-input--width-full-width": "_form-input--width-full-width_61szp_248",
  "form-input--width-fit-content": "_form-input--width-fit-content_61szp_252",
  "form-input--width-max-content": "_form-input--width-max-content_61szp_256",
  "form-input--width-min-content": "_form-input--width-min-content_61szp_260"
}, k = O(
  ({
    id: u,
    name: d,
    dataTestId: e,
    inputMode: h,
    autocomplete: z,
    placeholder: x,
    disabled: f = !1,
    minLength: w,
    maxLength: v,
    readonly: p = !1,
    required: s = !1,
    type: y = "text",
    affix: i,
    suffix: a,
    customWidth: b,
    hasDescription: N = !1,
    label: F,
    description: I,
    error: c,
    hideLabels: g,
    marginBottom: $,
    className: j,
    width: r = "default",
    // for backwards compat
    ...E
  }, B) => {
    const o = !!c, n = W({
      id: u,
      isError: !!o,
      hasDescription: N
    }), l = (C) => [b, r].includes(C);
    return /* @__PURE__ */ _(
      R,
      {
        fieldIds: n,
        label: F,
        error: c,
        description: I,
        hideLabels: g,
        marginBottom: $,
        children: /* @__PURE__ */ D(
          "div",
          {
            className: m(t["form-input"], j, {
              [t["form-input--disabled"]]: f,
              [t["form-input--readonly"]]: p,
              [t["form-input--error"]]: o,
              [t["form-input--width-default"]]: r === "default",
              [t["form-input--width-full-width"]]: r === "full-width",
              [t["form-input--width-min-content"]]: r === "min-content",
              [t["form-input--width-fit-content"]]: r === "fit-content",
              [t["form-input--width-max-content"]]: r === "max-content",
              [t["form-input--width-2ch"]]: l("2ch"),
              [t["form-input--width-4ch"]]: l("4ch")
            }),
            "data-testid": `form-input--${n.id}`,
            children: [
              i && /* @__PURE__ */ _(
                "div",
                {
                  className: m(
                    t["form-input__affix"],
                    t["form-input__affix--start"]
                  ),
                  children: i
                }
              ),
              /* @__PURE__ */ _(
                "input",
                {
                  id: u,
                  name: d,
                  "aria-describedby": n.describedBy,
                  "aria-invalid": o ? "true" : void 0,
                  "aria-disabled": f ? "true" : void 0,
                  "aria-required": s ? "true" : void 0,
                  "aria-readonly": p ? "true" : void 0,
                  readOnly: p,
                  required: s,
                  disabled: f,
                  ref: B,
                  className: m(t["form-input__control"], {
                    [t["form-input--invalid"]]: o,
                    [t[`form-input__control--affix--start--${i == null ? void 0 : i.length}ch`]]: i
                  }),
                  inputMode: h,
                  autoComplete: z,
                  minLength: w,
                  maxLength: v,
                  "data-testid": e || `form-input-field--${n.id}`,
                  type: y,
                  placeholder: x,
                  ...E
                }
              ),
              a ? /* @__PURE__ */ _("span", { className: t["form-input__suffix"], children: a }) : null
            ]
          }
        )
      }
    );
  }
);
k.displayName = "FormInput";
export {
  k as FormInput,
  k as default
};
